import { createContext } from "react"
import type { UserSubscription } from "@/features/subscriptions"

export type OpenScreens = {
  tarot: boolean
  runes: boolean
  numerology: boolean
}

export interface WebAppContextValue {
  hasNewMarkers: Record<string, boolean>
  removeMarker: (marker: string) => void
  openedDailyScreens: OpenScreens
  setOpenedDailyScreens: (v: OpenScreens) => void
  // Subscription info (delegated to the project's subscription store).
  userSubscription: UserSubscription | null
  isSubscriptionCanceled: boolean
  activeSubscriptionId: string | null
  checkUserSubscriptions: (uid: string) => void
  isStarReportPurchased: boolean
  isTruthsReportPurchased: boolean
  isSoulmateReportPurchased: boolean
  isAstroMapReportPurchased: boolean
  isAuraScanReportPurchased: boolean
  // Today-screen UI state.
  selectedSign: string
  setSelectedSign: (sign: string) => void
  selectedTimeRange: string
  setSelectedTimeRange: (range: string) => void
  isHoroscopeLoading: boolean
  setIsHoroscopeLoading: (loading: boolean) => void
  // Lets a full-bleed route (e.g. the compatibility report) hide the shell header.
  headerHidden: boolean
  setHeaderHidden: (hidden: boolean) => void
  // Extra bottom space (px) the routed content reserves under the fixed nav — set
  // by the nav to the height of the "New message received" banner so it doesn't
  // cover the page's bottom content. 0 when no banner is shown.
  bottomInset: number
  setBottomInset: (px: number) => void
}

export const WebAppContext = createContext<WebAppContextValue | null>(null)
